import { RR_TABLE_ACTION_TYPE } from '../../enum/table/table-action-type.enum';
import { RRISettings } from '../../interfaces/base-settings.interface';

export class RRTableActionModel<T>
  implements RRISettings<RR_TABLE_ACTION_TYPE, T>
{
  type: RR_TABLE_ACTION_TYPE;
  settings: T;
}
